import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { ClaimsTypes } from "@bbwt/modules/security/claims-types";
import { UserHelperService } from "@main/users/user-helper.service";
import { AccessDirectiveBase } from "./access-directive.base";

@Directive({
    selector: "[role]"
})
export class RoleDirective extends AccessDirectiveBase {
    constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef, userHelperService: UserHelperService) {
        super(templateRef, viewContainer, userHelperService);
    }

    protected get lookupClaimType(): string {
        return ClaimsTypes.Role;
    }

    @Input() set role(roleNames: string | string[]) {
        this.apply(roleNames);
    }
}
